import React from "react";
import {TextField} from "@mui/material";
import {forms, objects} from "@atttomyx/shared-utils";

const MessageForm = (props) => {
    const {label, data, onChange: onSync} = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = modified.message;

        onSync(modified);
    };

    return <div className="message-form">
        <div className="field top-margin">
            <TextField
                required={true}
                multiline={true}
                minRows={2}
                label={label}
                value={forms.sanitizeValue(data.message)}
                onChange={(event) => onChange("message", event.target.value)}
            />
        </div>
    </div>
}

export default MessageForm;
